// Generated by purs version 0.13.8
"use strict";
var Data_Board = require("../Data.Board/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Item = require("../Data.Item/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var Roomba = (function () {
    function Roomba() {

    };
    Roomba.value = new Roomba();
    return Roomba;
})();
var Drone = (function () {
    function Drone() {

    };
    Drone.value = new Drone();
    return Drone;
})();
var Bot = (function () {
    function Bot() {

    };
    Bot.value = new Bot();
    return Bot;
})();
var Fridge = (function () {
    function Fridge() {

    };
    Fridge.value = new Fridge();
    return Fridge;
})();
var Enemy = function (x) {
    return x;
};
var s = function (hp) {
    return function (armor) {
        return function (injuries) {
            return function (minDepth) {
                return function (weapon) {
                    return function (name1) {
                        return function (image1) {
                            return {
                                name: name1,
                                hp: hp,
                                armor: armor,
                                injuries: injuries,
                                minDepth: minDepth,
                                weapon: weapon,
                                image: image1
                            };
                        };
                    };
                };
            };
        };
    };
};
var stats = function (v) {
    if (v instanceof Roomba) {
        return s(2)(0)(10)(0)(Data_Item.Point.value)("murderous vacuum robot")("roomba.png");
    };
    if (v instanceof Bot) {
        return s(3)(3)(8)(2)(Data_Item.Point.value)("retired battlebot")("Battlebot1.png");
    };
    if (v instanceof Drone) {
        return s(1)(0)(5)(3)(Data_Item.Point.value)("kamikaze drone")("drone.png");
    };
    if (v instanceof Fridge) {
        return s(2)(8)(10)(4)(Data_Item.Point.value)("mobile fridge")("Fridge.png");
    };
    throw new Error("Failed pattern match at Data.Enemy (line 88, column 1 - line 88, column 32): " + [ v.constructor.name ]);
};
var recalculateClues = function (v) {
    var addClue = function (pos) {
        return function (clues) {
            return Data_Map_Internal.insert(Extra_Math.ordVector(Data_Ord.ordInt))(pos)(Data_Board.getClue(pos)(v.health.board))(clues);
        };
    };
    var clueCache = Data_Foldable.foldr(Data_Set.foldableSet)(addClue)(Data_Map_Internal.empty)(v.health.board.injuries);
    return {
        location: v.location,
        health: v.health,
        clueCache: clueCache,
        tag: v.tag
    };
};
var name = function (v) {
    return (stats(v.tag)).name;
};
var isAlive = function (v) {
    return Data_Board.isAlive(v.health);
};
var injureEnemy = function (bc) {
    return function (v) {
        var v1 = Data_Board.injure(bc)(v.health);
        var clue = Data_Board.getClue(bc)(v1.board);
        return {
            location: v.location,
            health: v1,
            clueCache: Data_Map_Internal.insert(Extra_Math.ordVector(Data_Ord.ordInt))(bc)(clue)(v.clueCache),
            tag: v.tag
        };
    };
};
var injureEnemyMulti = function (bcs) {
    return function (e) {
        return Data_Foldable.foldr(Data_Foldable.foldableArray)(injureEnemy)(e)(bcs);
    };
};
var image = function (v) {
    return (stats(v.tag)).image;
};
var enemyOnSpace = function (v) {
    return function (v1) {
        return Data_Eq.eq(Extra_Math.eqVector(Data_Eq.eqInt))(v1.location)(v);
    };
};
var allEnemies = [ Roomba.value, Drone.value, Bot.value, Fridge.value ];
module.exports = {
    enemyOnSpace: enemyOnSpace,
    injureEnemy: injureEnemy,
    recalculateClues: recalculateClues,
    injureEnemyMulti: injureEnemyMulti,
    Enemy: Enemy,
    isAlive: isAlive,
    Roomba: Roomba,
    Drone: Drone,
    Bot: Bot,
    Fridge: Fridge,
    allEnemies: allEnemies,
    name: name,
    image: image,
    s: s,
    stats: stats
};
